export const locationGroupEstimatesCacheKeys = {
  getByLocationGroupId: requestParams =>
    ['locationGroupEstimates', requestParams] as const
}
